// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"498":"b1321d42","1951":"13c5b028","5759":"e5227375"}[chunkId] + ".chunk.css";
};